import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";
import { Box, Typography } from "@material-ui/core";

export const SaveStatusContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    font-weight: bold;
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.hightownGreen.main};
    border-radius: 10px;
    padding: 0px 20px;

    .save-checkbox svg {
        height: 28px;
        width: 28px;
    }

    > p {
        margin: 12px 0 12px;
    }

    @media (max-width: 768px) {
        min-height: 48px;
        font-weight: bold;
        & > p {
            font-size: 16px;
        }
    }
`;
